import request from '@/router/axios';
import { Loading, Message } from 'element-ui';
export const getList = (current, size, params) => {
  return request({
    url: '/api/blade-system/tenant/list',
    method: 'get',
    params: {
      ...params,
      current,
      size,
    }
  })
}

export const getDetail = (id) => {
  return request({
    url: '/api/blade-system/tenant/detail',
    method: 'get',
    params: {
      id
    }
  })
}

export const remove = (ids) => {
  return request({
    url: '/api/blade-system/tenant/remove',
    method: 'post',
    params: {
      ids,
    }
  })
}

export const add = (row) => {
  return request({
    url: '/api/blade-system/tenant/submit',
    method: 'post',
    data: row
  })
}

export const update = (row) => {
  return request({
    url: '/api/blade-system/tenant/submit',
    method: 'post',
    data: row
  })
}

export const setting = (ids, form) => {
  return request({
    url: '/api/blade-system/tenant/setting',
    method: 'post',
    params: {
      ...form,
      ids
    }
  })
}

export const datasource = (tenantId, datasourceId) => {
  return request({
    url: '/api/blade-system/tenant/datasource',
    method: 'post',
    params: {
      tenantId,
      datasourceId
    }
  })
}

export const info = (domain) => {
  // domain = "https://hre-test.pms1.cn"
  return request({
    url: '/api/blade-system/tenant/info',
    method: 'get',
    params: {
      domain
    }
  })
  
 
   
}

// export const info = (domain) => {
//   domain = "https://hre-test.pms1.cn"
//   let data = request({
//     url: '/api/blade-system/tenant/info',
//     method: 'get',
//     params: {
//       domain
//     }
//   })
  
//   // console.log(data)
//   data.then((res,...a)=>{
//     console.log(res,a)
//     if(!res.data.data.tenantId){
//       Message.error(`该域名【${domain}】未配置，请尽快联系管理员！`);
//       return {}
//     }else{ 
//       let json = {
//         content:res.data.data.tenantId,
//         dataType:'string',
//         datetime:new Date().valueOf()

//       }
//       localStorage.setItem('saber-tenantId', JSON.stringify(json));
//       console.log(1111111111111111)
//       console.log(data)
    
//       return new Promise(function(resolve, reject){
//         resolve(res.data)
//       });
      
//     }
//   })
   
// }
